import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, ApiError } from "../lib/api";
import { Banner, Button, Card, Field, PageBody, PageHeader } from "../ui/Field";

export default function SiteNew() {
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [locale, setLocale] = useState("en");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.post("/api/sites", { name, slug, default_locale: locale });
      nav(`/sites/${slug}`);
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : (e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <PageBody className="max-w-2xl">
      <PageHeader
        eyebrow="№ Workspaces · New"
        title={<>A new <em>site</em></>}
        description="One CMS deployment hosts many static sites. Each gets its own pages, theme, assets, members, and Pages project."
      />
      {err && <Banner kind="error">{err}</Banner>}
      <Card number="S1" title="Basics">
        <form onSubmit={onSubmit}>
          <Field
            label="Name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (!slug) setSlug(slugify(e.target.value));
            }}
            placeholder="Acme Inc."
            required
          />
          <Field
            label="Slug"
            value={slug}
            onChange={(e) => setSlug(e.target.value.toLowerCase())}
            placeholder="acme"
            pattern="[a-z][a-z0-9-]{1,38}[a-z0-9]"
            help="Lowercase, 3–40 characters. Used in admin URLs and the default Pages subdomain."
            required
          />
          <Field label="Default locale" value={locale} onChange={(e) => setLocale(e.target.value)} placeholder="en" help="ISO 639-1 code." />
          <div className="flex items-center gap-3 mt-2">
            <Button type="submit" disabled={busy}>{busy ? "Creating…" : "Create site"}</Button>
            <Button type="button" variant="ghost" onClick={() => nav("/sites")}>Cancel</Button>
          </div>
        </form>
      </Card>
    </PageBody>
  );
}

function slugify(s: string) {
  return s.toLowerCase().replaceAll(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 40);
}
